import authInstance from "../Interceptor";

export const WholesalerDayReportByIdEffect = (wholesalerId, pageNo) => {
  return authInstance.get(
    `/reports/reportWholesalerDatewise?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const WholesalerMonthReportByIdEffect = (wholesalerId, pageNo) => {
  return authInstance.get(
    `/reports/reportWholesalerMonthwise?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const WholesalerWeekReportByIdEffect = (wholesalerId, pageNo) => {
  return authInstance.get(
    `/reports/reportWholesalerWeekwise?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&pagesize=10&pagination_required=true`
  );
};

export const WholesalerMonthDateSearchReportByIdEffect = ({
  wholesalerId,
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportWholesalerMonthwise?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};

export const WholesalerWeekDateSearchReportByIdEffect = ({
  wholesalerId,
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportWholesalerWeekwise?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};

export const WholesalerDayDateSearchReportByIdEffect = ({
  wholesalerId,
  pageNo,
  start_date,
  end_date,
}) => {
  return authInstance.get(
    `/reports/reportWholesalerlistDateWise?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&pagesize=10&pagination_required=true&start_date=${start_date}&end_date=${end_date}`
  );
};

export const WholesalerSearchReportByIdEffect = (wholesalerId) => {
  return authInstance.get(
    // `/reports/reportWholesaler?wholesaler_id=${wholesalerId}`
    `/reports/reportWholesalerDatewise?wholesaler_id=${wholesalerId}`
  );
};
